import {
  FaEye,
  FaEdit,
  FaPlus,
  FaTrash,
  FaPercent,
  FaCreditCard,
  FaExclamationTriangle,
  FaTable,
  FaHistory,
} from "react-icons/fa";

// =========================
// CRUD ACTIONS (globales)
// =========================
export const CRUD_ACTIONS = [
  {
    key: "LIST",
    label: "Listar",
    scopeSuffix: "list",
    icon: FaTable,
  },
  {
    key: "VIEW",
    label: "Ver",
    scopeSuffix: "view",
    icon: FaEye,
  },
  {
    key: "INSERT",
    label: "Crear",
    scopeSuffix: "insert",
    icon: FaPlus,
  },
  {
    key: "UPDATE",
    label: "Editar",
    scopeSuffix: "update",
    icon: FaEdit,
  },
  {
    key: "DELETE",
    label: "Eliminar",
    scopeSuffix: "delete",
    icon: FaTrash,
  },
];

// =========================
// BUSINESS ACTIONS POR MENU(la tabla permiso tiene contraint, hay que editar ahi tambien al editar aca, y en
// el backend la lista de permisos validos en el service de permisos)
// =========================
export const BUSINESS_ACTIONS_BY_MENU = {
  // =========================
  // DATOS CLIENTE (MENU 19)
  // =========================
  19: [
    {
      key: "FILTRO",
      label: "Filtro",
      scopeSuffix: "Filtro",
      icon: null,
    },
    {
      key: "DESCUENTOS",
      label: "Gestionar descuentos",
      scopeSuffix: "descuentos",
      icon: FaPercent,
    },
    {
      key: "TARJETAS",
      label: "Cambiar estado de tarjetas",
      scopeSuffix: "tarjetas",
      icon: FaCreditCard,
    },
    {
      key: "PINES",
      label: "Inactivar pines",
      scopeSuffix: "pines",
      icon: FaExclamationTriangle,
    },
  ],
//Actualización de Límite de Crédito
  20: [
    {
      key: "APROBAR_RECHAZAR",
      label: "Limite de Credito Aprobar/Rechazar",
      scopeSuffix: "aprobar_rechazar",
      icon: FaHistory,
    },
  ],
//modificacion masiva de tarjetas
  30: [
    {
      key: "EESS_A_TODAS_LAS_TARJETAS",
      label: "EE.SS. a Todas las tarjetas",
      scopeSuffix: "eess_a_todas_las_tarjetas",
      icon: null,
    },
    {
      key: "ASIGNAR_EESS_A_TARJETAS",
      label: "Asignar Estaciones a Tarjetas",
      scopeSuffix: "asignar_eess_a_tarjetas",
      icon: null,
    },
    {
      key: "ASIGNAR_PRODUCTOS_A_TARJETAS",
      label: "Asignar productos a Tarjetas",
      scopeSuffix: "asignar_productos_a_tarjetas",
      icon: null,
    },
  ],
};
